import React from 'react'
import { Navbar } from 'react-bootstrap'
import "../Views/HealthCheck.css"

const HealthNav = () => {
  return (
    <Navbar expand="lg" className="Health-nav">
        <Navbar.Brand href="#" className='Nav-title' as="div">Healthy check</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
    </Navbar>
  )
}

export default HealthNav
